'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef, useRef, useEffect } from 'react';
import { fieldObserver } from './field-observer.js';
import { useMergeRefs } from '../../utilities/hooks/use-merge-refs/use-merge-refs.js';

/**
 * Field component, used to wrap a form field.
 *
 * @example
 * <Field>
 *   <Label>Kort beskrivelse</Label>
 *   <Field.Description>Beskrivelse</Field.Description>
 *   <Input />
 *   <ValidationMessage>Feilmelding</ValidationMessage>
 * </Field>
 */
const Field = forwardRef(function Field({ className, position, asChild, ...rest }, ref) {
    const Component = asChild ? Slot : 'div';
    const fieldRef = useRef(null);
    const mergedRefs = useMergeRefs([fieldRef, ref]);
    useEffect(() => fieldObserver(fieldRef.current), []);
    return (jsx(Component, { className: cl('ds-field', className), "data-position": position, ref: mergedRefs, ...rest }));
});

export { Field };
